// Constants for inactivity timer configuration
export const INACTIVITY_CONFIG = {
  // Main inactivity timeout before warning (60 minutes)
  INACTIVITY_TIMEOUT: 60 * 60 * 1000,
  
  // Warning countdown time (2 minutes)  
  WARNING_TIMEOUT: 2 * 60 * 1000,
  
  // Countdown update interval
  COUNTDOWN_INTERVAL: 1000,
  
  // Activity events to listen for
  ACTIVITY_EVENTS: [
    'mousedown',
    'mousemove', 
    'keypress',
    'scroll',
    'touchstart',
    'touchmove',
    'touchend',
    'click',
    'keydown',
    'wheel',
    'pointerdown',
    'pointermove',
    'gesturestart',
    'gesturechange'
  ] as const,
} as const;

// Types for inactivity timer
export interface InactivityTimerConfig {
  inactivityTimeout?: number;
  warningTimeout?: number;
  countdownInterval?: number;
  activityEvents?: readonly string[];
}

export interface InactivityTimerState {
  showWarningModal: boolean;
  remainingTime: number;
  isActive: boolean;
}

export interface InactivityTimerActions {
  stayLoggedIn: () => void;
  logoutNow: () => void;
  resetTimer: () => void;
}

export type UseInactivityTimerReturn = InactivityTimerState & InactivityTimerActions;